import React from 'react'
import './components/Sections/contact/contact.scss'

function Message({text, color}) {
    return (
         <p style={{ backgroundColor: color }} className='message-text'>{text}</p>
    )
}

export default Message
